// extracted by mini-css-extract-plugin
module.exports = {"defiContainer":"styles_defiContainer__ToyJg","searchInputIcon":"styles_searchInputIcon__J_NSD"};